import { render, staticRenderFns } from "./CoachStaffPosition.vue?vue&type=template&id=b4447a2e&scoped=true&"
import script from "./CoachStaffPosition.vue?vue&type=script&lang=ts&"
export * from "./CoachStaffPosition.vue?vue&type=script&lang=ts&"
import style0 from "./CoachStaffPosition.vue?vue&type=style&index=0&id=b4447a2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4447a2e",
  null
  
)

export default component.exports